import { ModelBase } from '../../core/model/model-base';
import { ObjectComponentType } from './object-component-type';
export class ObjectComponentCategory extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.name = dataContext.name;
      this.objectComponentTypes = Array.isArray(dataContext.objectComponentTypes)
        ? dataContext.objectComponentTypes.map(x => {
            let i = new ObjectComponentType(x);
            return i;
          })
        : [];
    }
  }
  name: string = null;
  objectComponentTypes: ObjectComponentType[] = [];
}
